import { SessionTemplateTranslationDto } from "../../dto/sessions/session-template-translations.dto";
import { SessionTemplateTranslation } from "../../models/sessions/session-template.model";

export class SessionTemplateTranslationMapper {
  public static toModel(dto: SessionTemplateTranslationDto): SessionTemplateTranslation {
    return {
      languageId: dto.language_id,
      title: dto.title,
      subtitle: dto.subtitle,
      description: dto.description,
      placeholderTitle: dto.placeholder_title,
      coreChoiceQuestion: dto.core_choice_question,
      coreChoiceConstraint: dto.core_choice_constraint,
      refinerQuestion: dto.refiner_question,
      refinerConstraint: dto.refiner_constraint
    }
  }

  public static toDto(dto: SessionTemplateTranslation): SessionTemplateTranslationDto {
    return {
      language_id: dto.languageId,
      title: dto.title,
      subtitle: dto.subtitle,
      description: dto.description,
      placeholder_title: dto.placeholderTitle,
      core_choice_question: dto.coreChoiceQuestion,
      core_choice_constraint: dto.coreChoiceConstraint,
      refiner_question: dto.refinerQuestion,
      refiner_constraint: dto.refinerConstraint
    }
  }
}